<template>
  <div class="imagens-tab">
    <div v-if="!isLoading" class="px-6">
      <v-row v-if="midias.length" cols="12" sm="9" class="mt-5">
        <v-col
          v-for="(image, index) in midias"
          :key="index"
          class="d-flex child-flex"
          cols="4"
        >
          <v-card flat tile class="d-flex">
            <v-img
              :src="'data:image/jpg;base64,' + image"
              @click.stop="open(image, index)"
              aspect-ratio="1"
              contain
              class="grey lighten-2"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-card>
        </v-col>
        <v-dialog v-model="showFullScreen" max-width="800" isDark="">
          <v-card>
            <div>
              <v-btn
                fab
                dark
                small
                color="primary"
                style="position:absolute;top:200px;left:10px;z-index:1"
                @click="previous"
                ><v-icon>mdi-chevron-left</v-icon></v-btn
              >
              <v-btn
                fab
                dark
                small
                color="primary"
                style="position:absolute;right:10px;top:200px;z-index:1"
                @click="next"
                ><v-icon>mdi-chevron-right</v-icon></v-btn
              >
              <v-img :src="imgSrc" height="auto"></v-img>
            </div>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="toggleFullScreen" color="red darken-1" text>
                Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <v-alert
        v-else
        text
        prominent
        color="blue"
        class="mt-4"
        icon="mdi-folder-multiple-image"
      >
        Nenhuma imagem foi encontrada para este auto.
      </v-alert>
    </div>
    <div v-else>
      <v-overlay :value="true">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </div>
  </div>
</template>
<script>
import urlApi from "@/routes/urlApi";

export default {
  name: "ImagensTab",

  props: {
    idAuto: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      midias: [],
      isLoading: true,
      imgSrc: "",
      showFullScreen: false,
      currentIndex: "",
    };
  },

  methods: {
    getImages() {
      this.$http
        .get(`${urlApi}/v2/autos/${this.idAuto}/images`)
        .then((response) => {
          this.midias = response.data.images;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    previous() {
      this.currentIndex--;
      if (this.currentIndex < 0) {
        this.currentIndex = this.midias.length - 1;
      }
      const img = this.midias[this.currentIndex];
      this.imgSrc = "data:image/jpg;base64," + img;
    },
    next() {
      this.currentIndex++;
      if (this.currentIndex === this.midias.length) {
        this.currentIndex = 0;
      }
      const img = this.midias[this.currentIndex];
      this.imgSrc = "data:image/jpg;base64," + img;
    },
    open(image, index) {
      this.imgSrc = "data:image/jpg;base64," + image;
      this.currentIndex = index;
      this.toggleFullScreen();
    },
    toggleFullScreen() {
      this.showFullScreen = !this.showFullScreen;
    },
  },

  mounted() {
    this.getImages();
  },
};
</script>
<style scoped>
#print-button {
  position: absolute !important;
}
</style>
